import { render, staticRenderFns } from "./Predictions.vue?vue&type=template&id=3c58c8b3&scoped=true&"
import script from "./Predictions.vue?vue&type=script&lang=js&"
export * from "./Predictions.vue?vue&type=script&lang=js&"
import style0 from "./Predictions.vue?vue&type=style&index=0&id=3c58c8b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c58c8b3",
  null
  
)

export default component.exports